// import * as MyEarcut from "earcut";
import { Button, Control, Rectangle, TextBlock } from "@babylonjs/gui";
import { Color3 } from "@babylonjs/core/Maths/math.color";
import { Mesh } from "@babylonjs/core/Meshes/mesh";
import { CreateLines } from "@babylonjs/core/Meshes/Builders/linesBuilder";
import { CreateGround } from "@babylonjs/core/Meshes/Builders/groundBuilder";
import { CreateCylinder } from "@babylonjs/core/Meshes/Builders/cylinderBuilder";
import { CreatePlane } from "@babylonjs/core/Meshes/Builders/planeBuilder";
import { CreateRibbon } from "@babylonjs/core/Meshes/Builders/ribbonBuilder";
import { CreateDisc } from "@babylonjs/core/Meshes/Builders/discBuilder";
import { Quaternion } from "@babylonjs/core/Maths/math.vector";
import { Space } from "@babylonjs/core/Maths/math.axis";
import { Texture as BJSTexture } from "@babylonjs/core/Materials/Textures/texture";
import { TransformNode } from "@babylonjs/core/Meshes/transformNode";
import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { ElementGeometry } from "./ElementGeometry";
import { Util } from "../../utils/Util";
import { PbrMaterial } from '@egr/wcf/modules/core/mdl';
import { ShadowGenerator } from "@egr/wcf/modules/core/rendering/ShadowGenerator";
import { clamp } from "@egr/wcf/modules/utils/math";
export class RoomAR extends ElementGeometry {
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mPoints = new Array();
        this.mARWalls = new Array();
        this.mWidth = 0;
        this.mDepth = 0;
        this.mMaterial = 0;
        this.mColor = "#999999";
        this.mCenter = Vector3.Zero();
        this.mminPoint = Vector3.Zero();
        this.mmaxPoint = Vector3.Zero();
        this.mArea = 0;
        this.mPerimeter = 0;
        this.mClosedPolygon = false;
        this.mStartPoint = new Vector3(0, 0, 0);
        this.mStartPointSet = false;
        this.mARWallsNormals = new Array();
        this.mCurrentWallIndex = -1;
        this.mOpenings = new Array();
        this.mcurrentOpening = new Array();
        this.mOpeningType = "Door";
        this.mRoomElement.Params.ElementPoints = new Array();
        this.mRoomElement.Params.material = this.mRoomElement.material;
        this.mRoomElement.Params.materialColor = this.getInitialParams().color;
        this.mpickedWall = "";
        this.createARhelper();
    }
    getType() {
        return ("RoomAR");
    }
    setMesh(pMesh) {
        this.mArea = Util.calcMeshArea(pMesh) * 0.25;
    }
    get drawnMesh() {
        return (this.mMesh2d);
    }
    getPoints() {
        return this.mPoints;
    }
    getPointNumber() {
        return (this.mPoints.length);
    }
    width() {
        return this.mWidth;
    }
    depth() {
        return this.mDepth;
    }
    material() {
        return this.mMaterial;
    }
    center() {
        return this.mCenter;
    }
    minPoint() {
        return this.mminPoint;
    }
    maxPoint() {
        return this.mmaxPoint;
    }
    showInteractors(pShow) {
        if (this.mInteractors != null)
            this.mInteractors.showInteractors(pShow);
    }
    correctDirection() {
        let tClockwise = Util._clockWise3(this.mPoints);
        if (tClockwise)
            this.mPoints.reverse();
    }
    clearGUIText() {
        // clear text
        this.mGUI_length_TextBlock.text = "";
        // remove GUI control(s)
        this.mRoomManager.GUI2d.removeControl(this.mGUI_length_TextBlock);
        this.mRoomManager.GUI2d.removeControl(this.mGUI_length_Rect);
    }
    clear2dGUI() {
        this.clearGUIText();
        this.mRoomManager.GUI2d.clear();
    }
    setOpeningType(pType) {
        this.mOpeningType = pType;
    }
    setStatus(pStatus) {
        switch (this.mRoomElement.status) {
            case "AR_WallRecognition":
                this.mGUI_length_Rect.isVisible = false;
                this.mGUI_length_TextBlock.text = "";
                this.mGUI_length_TextBlock.isVisible = false;
                this.mCrossHair.visibility = 1;
                break;
            case "AR_DoorWindowRecognition":
                for (let tcontrol of this.mRoomManager.GUI2d._rootContainer.children) {
                    tcontrol.isVisible = true;
                }
                this.mGUI_length_Rect.isVisible = false;
                this.mGUI_length_TextBlock.text = "";
                this.mGUI_length_TextBlock.isVisible = false;
                break;
            default:
                break;
        }
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 0.5;
        tParams.height = 0.001;
        tParams.floorOffset = 0.0;
        tParams.color = this.mColor;
        return (tParams);
    }
    getparent() {
        return (this.mParent);
    }
    get Area() {
        return (this.mArea);
    }
    get Perimeter() {
        return (this.mPerimeter);
    }
    get AROpenings() {
        return (this.mOpenings);
    }
    get ARWalls() {
        return (this.mARWalls);
    }
    getLines() {
        let tRes = new Array();
        for (let i = 0; i < this.mRoomElement.Params.ElementPoints.length - 1; i++) {
            tRes.push([this.mRoomElement.Params.ElementPoints[i], this.mRoomElement.Params.ElementPoints[i + 1]]);
        }
        //tRes.push([this.mRoomElement.ElementParams.ElementPoints[this.mRoomElement.ElementParams.ElementPoints.length - 1], this.mRoomElement.ElementParams.ElementPoints[0]]);
        return (tRes);
    }
    create2dGeometry(pParent) {
        //
    }
    create3dGeometry(pParent) {
        let tEdge = this.createEdge(pParent);
        if (tEdge != null) {
            this.mRoomElement.setMesh3d(tEdge);
        }
    }
    getProperties() {
        let tProperties = new Array();
        return (tProperties);
    }
    serializeIOData() {
        return (this.mRoomElement.Params);
    }
    loadIOData(pData) {
        //
    }
    clearPoints(pPoints) {
        this.mPoints = [];
        this.mARWalls = [];
    }
    // tslint:disable-next-line:cyclomatic-complexity
    addPoint() {
        if (this.mRoomElement.status == "AR_WallRecognition") {
            this.mClosedPolygon = false;
            let tcurrentPos = this.mFloorViewPoint.position.clone();
            if (this.mPoints.length == 0) {
                tcurrentPos.y = 0;
                this.mPoints.push(tcurrentPos);
                this.mHeightPointPlane.setAbsolutePosition(this.mPoints[0]);
                this.mRoomManager.eventARFirstWallEdgeBottom.trigger(this.mRoomManager);
                this.mRoomElement.setARStartPoint(tcurrentPos);
                this.mRoomElement.setARStartPointSet(true);
            }
            else if (this.mPoints.length == 1) {
                if (this.mRoomElement.heightSet) {
                    tcurrentPos.y = 0;
                    this.mPoints.push(tcurrentPos);
                    this.mARWalls.push([this.mPoints[0], this.mPoints[1]]);
                }
                else {
                    this.mRoomElement.setHeight(tcurrentPos.y, false);
                    this.mRoomElement.HeightSet(true);
                    this.mCeilingPlane.position.y = tcurrentPos.y;
                    this.mRoomManager.eventARFirstWallEdgeTop.trigger(this.mRoomManager);
                }
            }
            else if (this.mPoints.length > 1) {
                tcurrentPos.y = 0;
                this.mPoints.push(tcurrentPos);
                let tmP_length = this.mPoints.length;
                this.mARWalls.push([this.mPoints[tmP_length - 2], this.mPoints[tmP_length - 1]]);
                let tfirstPoint = this.mPoints[0];
                let tlastPoint = this.mPoints[this.mPoints.length - 1];
                if (Util.vectorEquals3(tfirstPoint, tlastPoint, 0))
                    this.mClosedPolygon = true;
            }
            this.mRoomElement.setClosedPolygon(this.mClosedPolygon);
        }
        if (this.mRoomElement.status == "AR_DoorWindowRecognition") {
            let tcurrentPos = this.mFloorViewPoint.position.clone();
            if (this.mcurrentOpening.length == 0) {
                this.mcurrentOpening.push(tcurrentPos);
                this.mRoomManager.eventAROpeningsFilled.trigger(this.mRoomManager);
            }
            else if (this.mcurrentOpening.length == 1) {
                this.mcurrentOpening.push(tcurrentPos);
                let tAROpenings = {};
                tAROpenings.wallindex = this.mCurrentWallIndex;
                let tWallStart = this.mARWalls[tAROpenings.wallindex][0].clone();
                tWallStart.y = 0;
                // check start/end point of opening bottom_left, up_right
                let tlow = Math.min(this.mcurrentOpening[0].y, this.mcurrentOpening[1].y);
                let tHigh = Math.max(this.mcurrentOpening[0].y, this.mcurrentOpening[1].y);
                let tP0 = Util.to2d(this.mcurrentOpening[0]);
                let tP1 = Util.to2d(this.mcurrentOpening[1]);
                let tDist0 = Vector2.Distance(Util.to2d(tWallStart), tP0);
                let tDist1 = Vector2.Distance(Util.to2d(tWallStart), tP1);
                if (tDist0 < tDist1) {
                    tAROpenings.bottomLeft = this.mcurrentOpening[0];
                    tAROpenings.bottomLeft.y = tlow;
                    tAROpenings.upRight = this.mcurrentOpening[1];
                    tAROpenings.upRight.y = tHigh;
                }
                else {
                    tAROpenings.bottomLeft = this.mcurrentOpening[1];
                    tAROpenings.bottomLeft.y = tlow;
                    tAROpenings.upRight = this.mcurrentOpening[0];
                    tAROpenings.upRight.y = tHigh;
                }
                let tHP = tAROpenings.upRight.clone();
                tHP.y = tAROpenings.bottomLeft.y;
                tAROpenings.width = Vector3.Distance(tAROpenings.bottomLeft, tHP);
                tAROpenings.position = Util.to2d(Vector3.Center(tAROpenings.bottomLeft, tHP));
                // distance from wall startpoint
                let topeningStart = tAROpenings.bottomLeft.clone();
                topeningStart.y = 0;
                let tstartDist = Vector3.Distance(tWallStart, topeningStart);
                tAROpenings.startDistance = tstartDist;
                switch (this.mOpeningType) {
                    case "Door":
                    case "DoubleDoor":
                    case "GlassDoor":
                    case "GlassDoubleDoor":
                    case "GlassInlayDoor":
                    case "GlassInlayDoubleDoor":
                        tAROpenings.parapet = 0;
                        if (tAROpenings.bottomLeft.y > 0) {
                            tAROpenings.bottomLeft.y = 0;
                        }
                        break;
                    case "Window":
                    case "WindowDouble":
                    case "GlassFront":
                        tAROpenings.parapet = tAROpenings.bottomLeft.y;
                        break;
                    default:
                        break;
                }
                tAROpenings.height = tAROpenings.upRight.y - tAROpenings.bottomLeft.y;
                tAROpenings.type = this.mOpeningType;
                this.mOpenings.push(tAROpenings);
                this.mcurrentOpening = [];
            }
        }
    }
    removePoint() {
        if (this.mRoomElement.status == "AR_WallRecognition") {
            if (this.mPoints.length > 0) {
                this.mPoints.pop();
                this.mARWalls.pop();
                this.checkClosedPolygon();
                this.mRoomElement.setClosedPolygon(this.mClosedPolygon);
            }
            if (this.mPoints.length == 0) {
                this.mRoomElement.setARStartPointSet(false);
                this.mRoomElement.HeightSet(false);
                this.mRoomManager.eventEmptyARWalls.trigger(this.mRoomManager);
            }
        }
        if (this.mRoomElement.status == "AR_DoorWindowRecognition") {
            if (this.mcurrentOpening.length > 0) {
                this.mcurrentOpening.pop();
            }
            else if (this.mOpenings.length > 0) {
                this.mOpenings.pop();
            }
            if (this.mOpenings.length == 0) {
                this.mRoomManager.eventEmptyAROpenings.trigger(this.mRoomManager);
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    showViewPoint(pPos, pPickedMesh) {
        if (this.mFloorViewPoint == null)
            return;
        if (this.mRoomManager.view != null) {
            let tPos = pPos.clone();
            // first point - floor
            if (this.mPoints.length == 0) {
                this.mGUI_length_TextBlock.text = "";
                this.mGUI_length_Rect.isVisible = false;
                tPos.y = 0;
                this.mFloorViewPoint.position = tPos;
            }
            // second point - ceiling/height
            if (this.mPoints.length == 1) {
                if (this.mRoomElement.heightSet == false) {
                    this.mHeightPointPlane.name = "AR_height_grabber";
                    this.mFloorViewPoint.position.x = this.mPoints[0].x;
                    this.mFloorViewPoint.position.z = this.mPoints[0].z;
                    this.mFloorViewPoint.position.y = clamp(tPos.y, 0, 100.0);
                    this.mGUI_length_Rect.isVisible = false;
                    let tH = clamp(tPos.y, 0, 100.0);
                    let tHstr = tH.toLocaleString(this.mRoomManager.appLanguage, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    this.mGUI_length_TextBlock.text = this.mRoomManager.resources.propertyHeight + ": " + tHstr + Util.getLengthUnitString(this.mRoomManager.app.i18n.lengthUnit);
                    this.mGUI_length_Rect.isVisible = false;
                    this.drawHeightLine();
                }
                else {
                    this.mGUI_length_Rect.isVisible = false;
                    this.mGUI_length_TextBlock.text = "";
                    this.mFloorViewPoint.position = tPos;
                }
                this.drawCurrentWall();
            }
            // from third point - equal whether bottom or ceiling
            if (this.mPoints.length > 1) {
                let tpos1 = Util.to2d(this.mPoints[0]);
                let tpos2 = Util.to2d(pPos);
                switch (this.mRoomElement.status) {
                    case "AR_WallRecognition":
                        if (Util.vectorEquals2(tpos1, tpos2, 0.2)) {
                            this.mFloorViewPoint.position = Util.to3d(tpos1);
                        }
                        else {
                            this.mFloorViewPoint.position = tPos;
                        }
                        this.drawCurrentWall();
                        break;
                    case "AR_DoorWindowRecognition":
                        if (this.mcurrentOpening.length == 0) {
                            this.mFloorViewPoint.position = tPos;
                            this.mCurrentWallIndex = this.getWallIndex(pPickedMesh);
                            if (pPickedMesh.id != this.mpickedWall) {
                                this.mpickedWall = pPickedMesh.id;
                                let tmeshNormal = this.mARWallsNormals[this.mCurrentWallIndex];
                                let upVector = Vector3.Up();
                                let axis = Vector3.Cross(tmeshNormal, upVector).normalize();
                                let angle = Math.acos(Vector3.Dot(upVector, tmeshNormal));
                                this.mFloorViewPoint.rotationQuaternion = Quaternion.Identity();
                                this.mFloorViewPoint.rotate(axis, angle, Space.LOCAL);
                            }
                        }
                        else if (pPickedMesh.id == this.mpickedWall) {
                            this.mFloorViewPoint.position = tPos;
                        }
                        break;
                    default:
                        break;
                }
            }
            this.drawCurrentOpening();
        }
    }
    createARhelper() {
        this.mFloorPlane = CreateGround("ARfloor", { width: 10000, height: 10000 }, this.mScene);
        this.mFloorPlane.visibility = 0;
        // wall material
        this.mWallMaterial = new PbrMaterial("room element color #BBBBBB", this.mMatManager);
        this.mWallMaterial.albedoColor = Color3.FromHexString("#BBBBBB").toLinearSpace();
        this.mWallMaterial.metallic = 0;
        this.mWallMaterial.roughness = 1;
        this.mWallMaterial.emissiveColor = Color3.FromHexString("#FFFFFF").toLinearSpace();
        this.mWallMaterial.backFaceCulling = false;
        this.mWallMaterial.freeze();
        // disc material
        this.mCrossHairMat = new PbrMaterial("room element color #B9BAB6", this.mMatManager);
        this.mCrossHairMat.albedoColor = Color3.FromHexString("#B9BAB6").toLinearSpace();
        this.mCrossHairMat.metallic = 0;
        this.mCrossHairMat.roughness = 1;
        this.mCrossHairMat.emissiveColor = Color3.FromHexString("#FFFFFF").toLinearSpace();
        this.mCrossHairMat.backFaceCulling = false;
        this.mCrossHairMat.freeze();
        // door / window material
        this.mDoorWindowMat = new PbrMaterial("room element color #95C11F", this.mMatManager);
        this.mDoorWindowMat.albedoColor = Color3.FromHexString("#95C11F").toLinearSpace();
        this.mDoorWindowMat.metallic = 0;
        this.mDoorWindowMat.roughness = 1;
        this.mDoorWindowMat.emissiveColor = Color3.FromHexString("#95C11F").toLinearSpace();
        this.mDoorWindowMat.backFaceCulling = false;
        this.mDoorWindowMat.freeze();
        // parent node
        this.mFloorViewPoint = new TransformNode("", this.mScene);
        this.mFloorViewPoint.parent = this.mRoomElement.node;
        // crosshair
        let tcrossHairTexture = new BJSTexture(this.mRoomManager.dataPath + "textures/radial_gradient.png", this.mScene, undefined, false, BJSTexture.BILINEAR_SAMPLINGMODE, null, null, undefined, true);
        tcrossHairTexture.uScale = 1;
        tcrossHairTexture.vScale = 1;
        tcrossHairTexture.hasAlpha = true;
        let tCHalphaMat = new PbrMaterial("crosshair_alpha", this.mMatManager);
        tCHalphaMat.albedoTexture = tcrossHairTexture;
        tCHalphaMat.useAlphaFromAlbedoTexture = true;
        tCHalphaMat.emissiveColor = Color3.FromHexString("#FFFFFF");
        tCHalphaMat.backFaceCulling = false;
        tCHalphaMat.freeze();
        let talphaDisc = CreateCylinder("", { diameter: 0.22, tessellation: 30, height: 0.0005 }, this.mScene);
        talphaDisc.parent = this.mFloorViewPoint;
        talphaDisc.material = tCHalphaMat;
        talphaDisc.position = new Vector3(0, 0, 0);
        talphaDisc.visibility = 1;
        this.mCrossHair = talphaDisc;
        // connect local node to RoomElement node
        this.mHeightPointPlane = new TransformNode("", this.mScene);
        this.mHeightPointPlane.parent = this.mRoomElement.node;
        this.mHeightPointPlane.billboardMode = TransformNode.BILLBOARDMODE_Y;
        /*
        let mHeightPointPlane1 = MeshBuilder.CreateCylinder("AR_height_grabber", {diameter: 0.05, tessellation: 5, height: 100}, this.mScene);
        mHeightPointPlane1.parent = this.mHeightPointPlane;
        mHeightPointPlane1.material = tCHalphaMat;
        mHeightPointPlane1.position = new Vector3(0,0,0);
        mHeightPointPlane1.position.y = 50;
        mHeightPointPlane1.visibility = 1;
        */
        // invisible pick plane for height recognition
        let tSelectionPlane = CreatePlane("AR_height_grabber", {
            width: 200,
            height: 50
        }, this.mScene);
        tSelectionPlane.parent = this.mHeightPointPlane;
        tSelectionPlane.visibility = 0;
        // invisible pick plane for ceiling
        // connect local node to RoomElement node
        this.mCeilingPlane = new TransformNode("", this.mScene);
        this.mCeilingPlane.parent = this.mRoomElement.node;
        this.mCeilingPlane.position = new Vector3(0, 0, 0);
        let tceilingMesh = CreatePlane("ARceiling", {
            width: 10000,
            height: 10000
        }, this.mScene);
        tceilingMesh.parent = this.mCeilingPlane;
        tceilingMesh.position = new Vector3(0, 0, 0);
        tceilingMesh.rotation.x = -Math.PI / 2;
        tceilingMesh.isPickable = false;
        tceilingMesh.visibility = 0;
        // 2d GUI
        this.mGUI_length_TextBlock = new TextBlock("");
        this.mGUI_length_TextBlock.color = "white";
        this.mGUI_length_TextBlock.fontSize = 40;
        this.mGUI_length_TextBlock.top = 80;
        this.mGUI_length_Rect = new Rectangle();
        this.mGUI_length_Rect.width = 0.2;
        this.mGUI_length_Rect.height = "40px";
        this.mGUI_length_Rect.cornerRadius = 3;
        this.mGUI_length_Rect.color = "green";
        this.mGUI_length_Rect.thickness = 0;
        this.mGUI_length_Rect.background = "green";
        this.mGUI_length_Rect.top = 80;
        this.mGUI_length_Rect.isVisible = false;
        let tbtnDoor = Button.CreateSimpleButton("but1", "Door");
        tbtnDoor.width = "200px";
        tbtnDoor.height = "70px";
        tbtnDoor.cornerRadius = 0;
        tbtnDoor.thickness = 0;
        tbtnDoor.background = "orange";
        tbtnDoor.left = "0%";
        tbtnDoor.top = "160px";
        tbtnDoor.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        tbtnDoor.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        tbtnDoor.onPointerUpObservable.add(this._setOpeningType(this, "Door", tbtnDoor));
        tbtnDoor.name = "AR_Door";
        tbtnDoor.isVisible = false;
        let tbtnDoorGlassInlay = Button.CreateSimpleButton("but1", "Door with glass inlay");
        tbtnDoorGlassInlay.width = "200px";
        tbtnDoorGlassInlay.height = "70px";
        tbtnDoorGlassInlay.cornerRadius = 0;
        tbtnDoorGlassInlay.thickness = 0;
        tbtnDoorGlassInlay.background = "green";
        tbtnDoorGlassInlay.left = "0%";
        tbtnDoorGlassInlay.top = "240px";
        tbtnDoorGlassInlay.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        tbtnDoorGlassInlay.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        tbtnDoorGlassInlay.onPointerUpObservable.add(this._setOpeningType(this, "GlassInlayDoor", tbtnDoorGlassInlay));
        tbtnDoorGlassInlay.name = "AR_GlassInlayDoor";
        tbtnDoorGlassInlay.isVisible = false;
        let tbtnGlassDoor = Button.CreateSimpleButton("but1", "Glass Door");
        tbtnGlassDoor.width = "200px";
        tbtnGlassDoor.height = "70px";
        tbtnGlassDoor.cornerRadius = 0;
        tbtnGlassDoor.thickness = 0;
        tbtnGlassDoor.background = "green";
        tbtnGlassDoor.left = "0%";
        tbtnGlassDoor.top = "320px";
        tbtnGlassDoor.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        tbtnGlassDoor.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        tbtnGlassDoor.onPointerUpObservable.add(this._setOpeningType(this, "GlassDoor", tbtnGlassDoor));
        tbtnGlassDoor.name = "AR_GlassDoor";
        tbtnGlassDoor.isVisible = false;
        let tbtnWindow = Button.CreateSimpleButton("but1", "Window");
        tbtnWindow.width = "200px";
        tbtnWindow.height = "70px";
        tbtnWindow.cornerRadius = 0;
        tbtnWindow.thickness = 0;
        tbtnWindow.background = "green";
        tbtnWindow.left = "0%";
        tbtnWindow.top = "400px";
        tbtnWindow.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        tbtnWindow.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        tbtnWindow.onPointerUpObservable.add(this._setOpeningType(this, "Window", tbtnWindow));
        tbtnWindow.name = "AR_Window";
        tbtnWindow.isVisible = false;
        let tbtnWindowDouble = Button.CreateSimpleButton("but1", "GlassFront");
        tbtnWindowDouble.width = "200px";
        tbtnWindowDouble.height = "70px";
        tbtnWindowDouble.cornerRadius = 0;
        tbtnWindowDouble.thickness = 0;
        tbtnWindowDouble.background = "green";
        tbtnWindowDouble.left = "0%";
        tbtnWindowDouble.top = "480px";
        tbtnWindowDouble.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        tbtnWindowDouble.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        tbtnWindowDouble.onPointerUpObservable.add(this._setOpeningType(this, "GlassFront", tbtnWindowDouble));
        tbtnWindowDouble.name = "AR_GlassFront";
        tbtnWindowDouble.isVisible = false;
        this.mRoomManager.GUI2d.addControl(this.mGUI_length_Rect);
        this.mRoomManager.GUI2d.addControl(this.mGUI_length_TextBlock);
        if (this.mRoomManager.TestAppMode) {
            // wall opening buttons for debugging
            this.mRoomManager.GUI2d.addControl(tbtnDoor);
            this.mRoomManager.GUI2d.addControl(tbtnDoorGlassInlay);
            this.mRoomManager.GUI2d.addControl(tbtnGlassDoor);
            this.mRoomManager.GUI2d.addControl(tbtnWindow);
            this.mRoomManager.GUI2d.addControl(tbtnWindowDouble);
        }
    }
    _setOpeningType(_this, pType, pButton) {
        return (eventData, eventState) => {
            _this.mOpeningType = pType;
            for (let tcontrol of _this.mRoomManager.GUI2d._rootContainer.children) {
                tcontrol.background = "green";
                pButton.background = "orange";
            }
        };
    }
    checkClosedPolygon() {
        if (this.mPoints.length >= 2) {
            this.mClosedPolygon = Util.vectorEquals3(this.mPoints[0], this.mPoints[this.mPoints.length - 1]);
        }
        else
            this.mClosedPolygon = false;
        this.mRoomElement.setClosedPolygon(this.mClosedPolygon);
    }
    getWallIndex(pWallMesh) {
        let tRes = -1;
        let tmeshName = pWallMesh.name.replace("ARwall__", "");
        tRes = parseInt(tmeshName, 10);
        return (tRes);
    }
    drawHeightLine() {
        let tHP = clamp(this.mFloorViewPoint.position.y, 0.000001, 100.0);
        let tstick = CreateCylinder("", { diameter: 0.01, height: tHP, tessellation: 3 }, this.mScene);
        tstick.parent = this.mFloorViewPoint;
        tstick.position = new Vector3(0, 0, 0);
        tstick.position.y = -tHP * 0.5;
        let thStick = tstick;
        this.prepare3dMesh(thStick);
        if (thStick != null) {
            this.mHeightStick = thStick;
            this.mHeightStick.material = this.mCrossHairMat;
            this.mHeightStick.parent = this.mFloorViewPoint;
        }
    }
    drawCurrentWall() {
        if (this.mPoints.length == 0)
            return;
        if (!this.mRoomElement.heightSet)
            return;
        if (this.mClosedPolygon)
            return;
        if (this.mCurrentWall != undefined)
            this.mCurrentWall.dispose();
        // transparent wall
        let tSPf = this.mPoints[this.mPoints.length - 1].clone();
        let tEPf = this.mFloorViewPoint.position.clone();
        tSPf.y = 0;
        tEPf.y = 0;
        let tSPc = tSPf.clone();
        let tEPc = tEPf.clone();
        tSPc.y = this.mRoomElement.height;
        tEPc.y = this.mRoomElement.height;
        let tcurrentWallpath = [
            [tSPf,
                tEPf
            ],
            [tSPc,
                tEPc
            ]
        ];
        if (this.mLineB != null) {
            this.mLineB.dispose();
            this.mLineB = null;
        }
        if (this.mLineC != null) {
            this.mLineC.dispose();
            this.mLineC = null;
        }
        if (this.mLineE != null) {
            this.mLineE.dispose();
            this.mLineE = null;
        }
        this.mLineB = CreateLines("", { points: [tSPf, tEPf] }, this.mScene);
        this.mLineB.color = Color3.FromHexString("#95C11F");
        this.mLineB.parent = this.mRoomElement.group3d;
        this.mLineB.isPickable = false;
        this.mLineB.renderingGroupId = 1;
        ShadowGenerator.disableMeshShadow(this.mLineB);
        this.prepare3dMesh(this.mLineB);
        this.mLineC = CreateLines("", { points: [tSPc, tEPc] }, this.mScene);
        this.mLineC.color = Color3.FromHexString("#95C11F");
        this.mLineC.parent = this.mRoomElement.group3d;
        this.mLineC.isPickable = false;
        this.mLineC.renderingGroupId = 1;
        ShadowGenerator.disableMeshShadow(this.mLineC);
        this.prepare3dMesh(this.mLineC);
        this.mLineE = CreateLines("", { points: [tEPf, tEPc] }, this.mScene);
        this.mLineE.color = Color3.FromHexString("#95C11F");
        this.mLineE.parent = this.mRoomElement.group3d;
        this.mLineE.isPickable = false;
        this.mLineE.renderingGroupId = 1;
        ShadowGenerator.disableMeshShadow(this.mLineE);
        this.prepare3dMesh(this.mLineE);
        let tDist = Vector3.Distance(tSPf, tEPf);
        if ((this.mRoomElement.status == "AR_WallRecognition") && (this.mRoomElement.heightSet)) {
            let tDstr = tDist.toLocaleString(this.mRoomManager.appLanguage, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            this.mGUI_length_TextBlock.text = this.mRoomManager.resources.propertyLength + ": " + tDstr + Util.getLengthUnitString(this.mRoomManager.app.i18n.lengthUnit);
            this.mGUI_length_Rect.isVisible = false;
        }
    }
    drawCurrentOpening() {
        if (this.mcurrentOpening.length == 0)
            return;
        // transparent wall
        let tviewPoint = this.mFloorViewPoint.position.clone();
        let tSP_bottom = this.mcurrentOpening[0].clone();
        let tEP_bottom = this.mFloorViewPoint.position.clone();
        tEP_bottom.y = tSP_bottom.y;
        let tSP_up = tSP_bottom.clone();
        tSP_up.y = tviewPoint.y;
        let tEP_up = this.mFloorViewPoint.position.clone();
        let tcurrentDoor = [
            [tSP_bottom,
                tEP_bottom
            ],
            [tSP_up,
                tEP_up
            ]
        ];
        //Create ribbon with updatable parameter set to true for later changes
        let tcurrDoor = CreateRibbon("ribbon", { pathArray: tcurrentDoor, sideOrientation: Mesh.DOUBLESIDE, updatable: true }, this.mScene);
        tcurrDoor.material = this.mDoorWindowMat;
        tcurrDoor.parent = this.mRoomElement.group3d;
        tcurrDoor.visibility = 0.2;
        ShadowGenerator.disableMeshShadow(tcurrDoor);
        this.prepare3dMesh(tcurrDoor);
    }
    drawWalls(pParent) {
        if (this.mPoints.length < 2)
            return;
        let tFloorPath = new Array();
        let tCeilingPath = new Array();
        this.mARWallsNormals = [];
        // draw serveral walls
        for (let i = 0; i < this.mPoints.length - 1; i++) {
            tFloorPath = [];
            tCeilingPath = [];
            // floor points
            // start point
            let tPosFS = this.mPoints[i].clone();
            tPosFS.y = 0;
            tFloorPath.push(tPosFS);
            // end point
            let tPosFE = this.mPoints[i + 1].clone();
            tPosFE.y = 0;
            tFloorPath.push(tPosFE);
            // ceiling points
            // start point
            let tPosCS = this.mPoints[i].clone();
            tPosCS.y = this.mRoomElement.height;
            tCeilingPath.push(tPosCS);
            // end point
            let tPosCE = this.mPoints[i + 1].clone();
            tPosCE.y = this.mRoomElement.height;
            tCeilingPath.push(tPosCE);
            let tARWall = CreateRibbon("ARwall__" + i.toString(), { pathArray: [tFloorPath, tCeilingPath], sideOrientation: Mesh.DOUBLESIDE, updatable: true }, this.mScene);
            tARWall.material = this.mWallMaterial;
            // calculate normal vector
            let tV1 = tPosFE.subtract(tPosFS);
            let tV2 = tPosCS.subtract(tPosFS);
            let tnormal = Vector3.Cross(tV1, tV2);
            this.mARWallsNormals[i] = tnormal;
            tARWall.visibility = 0.1;
            tARWall.parent = pParent;
            this.prepare3dMesh(tARWall);
        }
    }
    drawOpenings(pParent) {
        if (this.mOpenings.length == 0)
            return;
        for (let i = 0; i < this.mOpenings.length; i++) {
            let tDoor = this.mOpenings[i];
            let tPU1 = tDoor.bottomLeft.clone();
            let tPU2 = tDoor.upRight.clone();
            tPU1.y = tPU2.y;
            let tPB1 = tDoor.bottomLeft.clone();
            let tPB2 = tDoor.upRight.clone();
            tPB2.y = tPB1.y;
            let tpathUp = [];
            let tpathBottom = [];
            tpathUp.push(tPU1, tPU2);
            tpathBottom.push(tPB1, tPB2);
            let tARDoor = CreateRibbon("ARDoor__" + i.toString(), { pathArray: [tpathUp, tpathBottom], sideOrientation: Mesh.DOUBLESIDE, updatable: true }, this.mScene);
            tARDoor.material = this.mDoorWindowMat;
            tARDoor.visibility = 0.2;
            tARDoor.renderingGroupId = 1;
            tARDoor.parent = pParent;
            this.prepare3dMesh(tARDoor);
        }
    }
    createEdge(pParent) {
        if (this.mPoints.length == 0)
            return (null);
        let tStickArray = [];
        for (let tPoint of this.mPoints) {
            // disc on ground
            let tDiscPos = tPoint.clone();
            let tgroundDisc = CreateDisc("disc", { radius: 0.03, tessellation: 30 }, this.mScene);
            tgroundDisc.material = this.mCrossHairMat;
            tgroundDisc.position = tDiscPos;
            tgroundDisc.rotation.x = Math.PI / 2;
            tgroundDisc.renderingGroupId = 1;
            this.prepare3dMesh(tgroundDisc);
            tStickArray.push(tgroundDisc);
            if (this.mRoomElement.heightSet) {
                let tceilingDisc = CreateDisc("disc", { radius: 0.03, tessellation: 30 }, this.mScene);
                tceilingDisc.material = this.mCrossHairMat;
                tceilingDisc.position = tDiscPos.clone();
                tceilingDisc.position.y = this.mRoomElement.height;
                tceilingDisc.rotation.x = Math.PI / 2;
                tceilingDisc.renderingGroupId = 1;
                this.prepare3dMesh(tceilingDisc);
                tStickArray.push(tceilingDisc);
            }
        }
        // wall lines bottom
        let tLinesBottom = CreateLines("", { points: this.mPoints }, this.mScene);
        tLinesBottom.color = Color3.FromHexString("#95C11F");
        tLinesBottom.parent = pParent;
        tLinesBottom.isPickable = false;
        tLinesBottom.renderingGroupId = 1;
        ShadowGenerator.disableMeshShadow(tLinesBottom);
        this.prepare3dMesh(tLinesBottom);
        if (this.mRoomElement.heightSet) {
            let tmPointsUp = [];
            for (let tPoint of this.mPoints) {
                let tPointUp = tPoint.clone();
                tPointUp.y = this.mRoomElement.height;
                tmPointsUp.push(tPointUp);
                // edge lines
                let tLinesEdge = CreateLines("", { points: [tPoint, tPointUp] }, this.mScene);
                tLinesEdge.color = Color3.FromHexString("#7F7F7F");
                tLinesEdge.parent = pParent;
                tLinesEdge.isPickable = false;
                tLinesEdge.renderingGroupId = 1;
                ShadowGenerator.disableMeshShadow(tLinesEdge);
                this.prepare3dMesh(tLinesEdge);
            }
            // wall lines ceiling
            let tLinesCeiling = CreateLines("", { points: tmPointsUp }, this.mScene);
            tLinesCeiling.color = Color3.FromHexString("#95C11F");
            tLinesCeiling.parent = pParent;
            tLinesCeiling.isPickable = false;
            tLinesCeiling.renderingGroupId = 1;
            ShadowGenerator.disableMeshShadow(tLinesCeiling);
            this.prepare3dMesh(tLinesCeiling);
        }
        /*
        // draw closed floor plan
        let tfloorPlane = new PolygonMeshBuilder("ARclosedFloor", Util.to2dArray(this.mPoints) , this.mScene, MyEarcut);
        let tfloorPolygon = tfloorPlane.build(false, 0.0001);
        tfloorPolygon.material = this.mRoomElement.MeshMaterial;
        (tfloorPolygon.material as PbrMaterial).albedoColor = Color3.FromHexString("#95C11F");
        tfloorPolygon.visibility = 0.2;
        tfloorPolygon.isPickable = true;
        tfloorPolygon.parent = pParent;
        tfloorPolygon.material = this.mRoomElement.MeshMaterial;
        tfloorPolygon.material.backFaceCulling = true;
        tfloorPolygon.position.y = 0;
        ShadowGenerator.disableMeshShadow(tfloorPolygon);
        this.prepare3dMesh(tfloorPolygon);
        */
        this.drawWalls(pParent);
        this.drawOpenings(pParent);
        let tmergedSticks = Mesh.MergeMeshes(tStickArray, true);
        if (tmergedSticks != null) {
            tmergedSticks.parent = pParent;
            return (tmergedSticks);
        }
        return (null);
    }
}
